// NOTE: 長崎・五島福江用の処置
// 国情報のJSONから検索用のコードを取得
const language = require('../data/langage.json');

// Domestic Flights
export default $target => {
  // 表示中ページの地域
  const countrycode = location.pathname.split('/')[2]; // eslint-disable-line
  const country = language.country.find(({ id }) => id === countrycode);

  Array.prototype.forEach.call($target, param => {
    param.value = country.connection_kind; // eslint-disable-line
  });
};
